import { Col, Row } from 'antd';
import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import dollarSign from '../../../assets/images/referral/investor-$-sign.svg';
import investorBanner from '../../../assets/images/referral/referral-banner.png';
// import percentageSign from '../../../assets/images/referral/investor-percentage-sign.svg';
import { RootState } from '../../../store/rootReducer';
// import HSButton from '../../common/Button';
import { MdOutlineContentCopy } from 'react-icons/md';
import Apis from '../../../api';
import telegram from '../../../assets/images/cib_telegram-plane.svg';
import whatsapp from '../../../assets/images/logos_whatsapp.svg';
import messanger from '../../../assets/images/messanger.svg';
import LinkButton from '../../common/LinkButton';
import Loader from '../../common/Loader';
import MessageActions from '../../message/redux/actions';
import ReferralTable from '../Referral/components/ReferralTable';
import ReferralFirstBlock from '../Referral/components/firstBlock';
import FourthBlock from '../Referral/components/fourthBlock';
import FifthBlock from '../Referral/components/terms&conditionsBlock';
import ReferralView from '../Referral/components/thirdBlock';
import ReferralsActions from '../Referral/redux/actions';
import Section2Form from './Components/Section2Form';

const values = {
    title: 'Share YOUR referral link',
    subText: 'Copy and send your referral link or share it on your social media.',
    howItWorks: 'How it works',
};

const ReferralNew: React.FC = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user.user);
    const uuid = useSelector((state: RootState) => state.user?.uuid);
    const userStatus = useSelector((state: RootState) => state.user.investor?.status.profile) || '';
    const loading = useSelector((state: RootState) => state.investments.loading);
    const referralUrl = `${window.location.origin}/referral/${user && user.referralCode}`;
    const [isTableOpen, setIsTableOpen] = useState(false);
    const [isEligible, setEligible] = useState(false);
    const [eligibleLoader, setEligibleLoader] = useState(false);
    const [referralCode, setReferralCode] = useState('');

    useLayoutEffect(() => {
        if (uuid) {
            setEligibleLoader(true);
            dispatch(ReferralsActions.getReferralDetail(uuid));
            Apis.getIsEligibleReferrar()
                .then((res) => {
                    if (res) {
                        setEligible(res.data);
                        setEligibleLoader(false);
                    }
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                    setEligible(false);
                    setEligibleLoader(false);
                })
                .finally(() => setEligibleLoader(false));
        }
    }, [dispatch, uuid]);

    const onEnterReferralCode = () => {
        if (referralCode && uuid) {
            Apis.addReferral(uuid, { code: referralCode })
                .then((res) => {
                    if (res) {
                        setEligible(false);
                        dispatch(MessageActions.showMessage({ error: false, text: 'Referral added successfully' }));
                    }
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                });
            setReferralCode('');
        }
    };

    const copyToClipboard = (text: string): void => {
        navigator.clipboard.writeText(text).then(
            function () {
                dispatch(MessageActions.showMessage({ error: false, text: `Copied!` }));
            },
            function (err) {
                console.error('Could not copy text: ', err);
            },
        );
    };
    const scrollToInvitedFriend = () => {
        const element = document?.getElementById('invite_your_friend');
        if (element) {
            const topOffset = element.getBoundingClientRect().top - 50;
            window.scrollTo({ top: window.scrollY + topOffset, behavior: 'smooth' });
        }
    };

    const socialMediaIcon = [
        {
            icon: whatsapp,
            name: 'whatsapp',
            link: `https://api.whatsapp.com/send?text=Helicap is an MAS-licensed private investment company that provides access to only the best-in-class private debt and equity opportunities in South East Asia. I am currently using it and would like to invite you to sign up (no investment required) to find out more: ${referralUrl}`,
        },
        {
            icon: messanger,
            name: 'fb-messanger',
            link: `fb-messenger://share?link=${referralUrl}`,
        },
        {
            icon: telegram,
            name: 'telegram',
            link: `tg://msg?text=Helicap is an MAS-licensed private investment company that provides access to only the best-in-class private debt and equity opportunities in South East Asia. I am currently using it and would like to invite you to sign up (no investment required) to find out more: ${referralUrl}`,
        },
        // {
        //     icon: emailIcon,
        //     name: 'email',
        //     link: `mailto:?subject=Alternative investing with Helicap&body=Hi,%0a%0a“Alternative investments managed in the Asia Pacific region may reach almost $5 trillion by 2025, as strong investor appetite in the fast-growing area drives the biggest increase in the world” - Bloomberg%0a%0aI’ve found that Helicap has an array of quality private investment opportunities right on their digital platform. Instead of gathering as many investments as they can on their platform, they are highly selective and work hard to find the best opportunities for their clients.%0a%0aI've started my investment with Helicap Pte Ltd and believe that you may also be interested to check out their offerings.
        // %0a%0aSign up here ${referralUrl} to check out their investments.%0a%0a[Helicap is an MAS-licensed private investment company.]`,
        // },
    ];
    return (
        <div className="bg-white" id="referral_new">
            <div>
                <div className="flex justify-between items-center flex-col md:flex-row bg-[#13223E] md:pl-24">
                    <div className="banner_details md:w-1/2 lg:w-1/3 xl:w-1/2 hidden md:block">
                        <div className="flex flex-col items-center justify-center w-3/4">
                            <div>
                                <p className="font-[WorkSans-Semibold] text-white text-[56px] uppercase">
                                    Refer an Investor,
                                </p>
                                <p className="font-[WorkSans-Semibold] text-[#41D17E] text-[56px] uppercase">
                                    Earn up to 10k*
                                </p>
                            </div>
                            <div className="ml-8 mt-8">
                                <p className="text-lg text-white font-[WorkSans]">
                                    Invite investors to join the Helicap community and earn $500! Get rewarded when your
                                    referrals invest in the Helicap fund or securities projects within 6 months.
                                </p>
                                <div className="py-8">
                                    {/* <HSButton
                                        title="Refer Now"
                                        isArrow={true}
                                        onClick={scrollToInvitedFriend}
                                        loading={loading}
                                    /> */}
                                    <LinkButton
                                        title="Get Started"
                                        loading={loading}
                                        onClick={scrollToInvitedFriend}
                                        isArrow
                                        variant="light"
                                        size="sm"
                                    />
                                </div>
                                {/* <span className="text-xs text-justify font-[Lato]" style={{ color: '#ACACAC' }}>
                                    *Subject to T&C
                                </span> */}
                            </div>
                        </div>
                        {/* <p>Refer friends and get rewarded</p>
                        <label className="text-lg">
                            Refer a friend and receive $500 when they join our community! Your referral’s investment
                            into any Helicap fund or securities project within 6 months rewards you. Sign up for a
                            Helicap account to access deals, data, and a teeming network of investors today.
                        </label> */}
                    </div>
                    <div className="w-full md:w-1/2 lg:w-2/3 xl:w-1/2">
                        <div className="banner_details w-full md:hidden block px-4">
                            {/* <div className="flex items-end justify-center"> */}
                            {/* <label>Refer an Investor and earn up to USD 10k*</label> */}
                            <p className="font-[WorkSans-Semibold] text-white text-[26px] uppercase">
                                Refer an Investor,
                            </p>
                            <p className="font-[WorkSans-Semibold] text-[#41D17E] text-[26px] uppercase">
                                Earn up to 10k*
                            </p>
                            {/* </div> */}
                        </div>
                        <div>
                            {/* <div className="circle rounded-full absolute" /> */}
                            <div>
                                <div>
                                    <div>
                                        <img src={investorBanner} alt="investorBanner" className="w-full" />
                                    </div>
                                    {/* <div className="card banner_image_amount flex justify-center items-center p-2 w-2/3">
                                        <div className="w-1/4">
                                            <img src={dollarSign} alt="investor-dollar-sign" />
                                        </div>
                                        <div className="w-3/4 pl-4">
                                            <p className="text-xs md:text-sm font-bold !font-[Lato] ">
                                                Your friend John makes an investment
                                            </p>
                                        </div>
                                    </div> */}
                                    {/* <div className="card banner_image_investment flex items-center p-2 w-1/2">
                                        <div className="w-1/4">
                                            <img
                                                src={percentageSign}
                                                alt="investor-percentage-sign"
                                                className="w-1/4"
                                            />
                                        </div>
                                        <div className="w-3/4 pl-4">
                                            <p className="text-xs md:text-sm !font-[Lato-Semibold]">You receive</p>
                                            <label className="text-sm md:text-base text-center !font-[Lato-Semibold]">
                                                $500*
                                            </label>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner_details w-full md:hidden block p-4">
                        <div className="flex flex-col items-end justify-center">
                            {/* <label >Refer an Investor and earn up to USD 10k*</label> */}
                            <div>
                                <p className="text-sm text-white font-[WorkSans]">
                                    Invite investors to join the Helicap community and earn $500! Get rewarded when your
                                    referrals invest in the Helicap fund or securities projects within 6 months.
                                </p>
                                <div className="flex justify-start items-center py-4 !WorkSans">
                                    {/* <HSButton
                                        title="Refer Now"
                                        isArrow={true}
                                        onClick={scrollToInvitedFriend}
                                        loading={loading}
                                    /> */}
                                    <LinkButton
                                        title="Get Started"
                                        loading={loading}
                                        onClick={scrollToInvitedFriend}
                                        isArrow
                                        variant="light"
                                        size="sm"
                                    />
                                </div>
                                {/* <span className="text-xs text-justify" style={{ color: '#ACACAC' }}>
                                    *Subject to T&C
                                </span> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* How it works */}
                <div>
                    <ReferralView />
                    {/* copyToClipboard={(text) => copyToClipboard(text)} */}
                </div>

                <div className="section2 bg-[#E1EBF8]">
                    <Row className="md:py-8 md:px-12 ">
                        <Col xs={24} md={12} id="invite_your_friend" className="border-r border-[#FFF]">
                            <Section2Form />
                        </Col>
                        <Col xs={24} md={12}>
                            <div className="w-full md:w-4/5 px-4 py-8 md:px-8">
                                <div>
                                    <div className="md:pl-8 text-2xl">
                                        <span className="text-[#13974b] text-6xl md:text-8xl font-[WorkSans-Semibold]">
                                            “
                                        </span>
                                        <p className="pl-4 md:pl-8 text-[#13223E] text-[32px] md:text-[45px] leading-tight font-[WorkSans-Semibold]">
                                            A referral is the highest form of flattery and the greatest compliment one
                                            can receive.&nbsp;
                                            {/* <span className="absolute -bottom-[1.8rem]">”</span> */}
                                        </p>
                                    </div>
                                    <div className="mt-4 pl-4 md:pl-16">
                                        <label className="font-[WorkSans-Semibold] text-[#6D707B] text-start">
                                            Chris Murray
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="referral_third_block w-full p-4 md:py-8 md:px-20">
                        <p className="font-[WorkSans-Bold] not-italic font-bold uppercase text-[#13223E] py-2 md:py-0 text-xl text-left">
                            {values.title}
                        </p>
                        <p className="font-[WorkSans] text-[#6D707B] not-italic font-normal text-sm md:text-base md:pt-3 text-left">
                            {values.subText}
                        </p>
                        <div className="md:flex md:pt-6">
                            <div className="bg-[#fff] w-full h-auto flex-col md:flex-row md:h-12 my-4 md:my-0 py-2 md:py-0 flex items-center justify-between px-8 overflow-hidden">
                                <p className="text-[#6D707B] text-base font-[WorkSans]">{referralUrl}</p>
                                <div className="flex justify-center py-2 md:py-0">
                                    <div className="mx-4 flex justify-center items-center">
                                        <MdOutlineContentCopy
                                            onClick={() => copyToClipboard(`${referralUrl}`)}
                                            className="text-2xl cursor-pointer text-[#142C53]"
                                        />
                                    </div>
                                    {socialMediaIcon.map((item, i) => (
                                        <div key={i + 9} className="mx-2 flex justify-center items-center">
                                            <a href={item.link} target={'_blank'} rel="noreferrer">
                                                <img src={item.icon} alt={item.name} className="h-6 w-6" />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <FourthBlock setIsTableOpen={() => setIsTableOpen(true)} userStatus={userStatus} />
                </div>
                {!eligibleLoader && isEligible && (
                    <div>
                        <ReferralFirstBlock
                            setReferralCode={(value: string) => setReferralCode(value)}
                            referralCode={referralCode}
                            onEnterReferralCode={() => onEnterReferralCode()}
                        />
                    </div>
                )}
                {eligibleLoader && (
                    <div className="flex justify-center items-center m-4">
                        <Loader />
                    </div>
                )}
                <FifthBlock />

                {/* Referral table popup */}
                {isTableOpen && (
                    <ReferralTable
                        loading={loading}
                        isTableOpen={isTableOpen}
                        userStatus={userStatus}
                        setIsTableOpen={(isOpen) => setIsTableOpen(isOpen)}
                    />
                )}
            </div>
        </div>
    );
};

export default ReferralNew;
